import { iApiEndpoint } from '../../context/ApiEndpointsContext';

export const AOL_BUNKER_CACHE_ENDPOINT_KEYS = [
    'getNoonReportsForShip',
    'getNoonReportStatuses',
    'getNoonReportSection',
    'getBunkeringEvents',
    'getBunkerings',
    'getFuelRobData',
    'getBunkerLossData',
] as const;

export type AolBunkerCacheEndpointKey = (typeof AOL_BUNKER_CACHE_ENDPOINT_KEYS)[number];

export const AOL_BUNKER_DEFAULT_URLS: Record<AolBunkerCacheEndpointKey, string> = {
    getNoonReportsForShip: 'GetNoonReportsForShip',
    getNoonReportStatuses: 'GetNoonReportStatuses',
    getNoonReportSection: 'GetNoonReportSection',
    getBunkeringEvents: 'GetBunkeringEvents',
    getBunkerings: 'GetBunkerings',
    getFuelRobData: 'GetFuelRobData',
    getBunkerLossData: 'GetBunkerLossData',
};

// apiEndpoints is supplied either as the (structurally map-shaped) context value
// typed as iApiEndpoint[], or as a plain lookup Record in tests/callers that only
// provide the fields this function needs. Both shapes support keyed .url lookup.
export const resolveAolBunkerCacheEndpoints = (
    apiEndpoints?: iApiEndpoint[] | Record<string, { url: string } | undefined>
): string[] => {
    return AOL_BUNKER_CACHE_ENDPOINT_KEYS.map((key) => apiEndpoints?.[key]?.url ?? AOL_BUNKER_DEFAULT_URLS[key]);
};

export const isAolOrBunkerPath = (pathname?: string | null): boolean => {
    if (!pathname) {
        return false;
    }
    const normalized = pathname.replace(/\/+$/, '').toLowerCase();
    return normalized === '/aol' || normalized === '/bunkering';
};

export const AOL_BUNKER_RECONNECT_NOTICE = {
    title: 'Reconnected for live updates.',
    message: 'If other users changed AOLs while you were offline, you may have missed updates. Consider refreshing the page.',
} as const;

export const RECONNECT_NOTICE_TOAST_ID = 'reconnect-live-updates-notice';
